export const ACCOUNT = 'ACCOUNT';
export const ACTIVITY = 'ACTIVITY';
export const ADD_RIGHTS = 'ADD_RIGHTS';
export const ALERT = 'ALERT';
export const ALERT_DANGER = 'danger';
export const ALERT_INFO = 'info';
export const ALERT_SUCCESS = 'success';
export const ALERT_WARNING = 'warning';
export const ALL_BOOKS = 'ALL_BOOKS';
export const ALL_COMPANIES = 'ALL_COMPANIES';
export const APPROVED = 'APPROVED';
export const ARROW_UP = 'ARROW_UP';
export const AUTOMATIC = 'AUTOMATIC';
export const AVAILABLE = 'AVAILABLE';
export const BEAKER = 'BEAKER';
export const BELL = 'BELL';
export const BELL_SLASH = 'BELL_SLASH';
export const BOOKLIST = 'BOOKLIST';
export const BOOKLIST_MANAGER = 'BOOKLIST_MANAGER';
export const BOOKLISTS_ACTIVE = 'ACTIVE';
export const BOOKLISTS_ALL = 'ALL';
export const BOOKLISTS_ARCHIVED = 'ARCHIVED';
export const BOOKSHELF = 'BOOKSHELF';
export const BOOK_COVER = 'BOOK_COVER';
export const CALCULATE = 'CALCULATE';
export const CANCEL = 'CANCEL';
export const CANCELLED = 'CANCELLED';
export const CHECKMARK = 'CHECKMARK';
export const CHEVRON = 'CHEVRON';
export const CHILD = 'CHILD';
export const CHILD_COMPANIES = 'CHILD_COMPANIES';
export const CIRCLE_CHECK = 'CIRCLE_CHECK';
export const CIRCLE_CHECK_OPEN = 'CIRCLE_CHECK_OPEN';
export const CIRCLE_EXCLAMATION = 'CIRCLE_EXCLAMATION';
export const CIRCLE_INFO = 'CIRCLE_INFO';
export const CIRCLE_PLUS = 'CIRCLE_PLUS';
export const CLOSE = 'CLOSE';
export const COLLEGE = 'COLLEGE';
export const COMMENT = 'COMMENT';
export const COMPANY = 'COMPANY';
export const COURSES = 'COURSES';
export const DELETE_ITEMS = 'DELETE_ITEMS';
export const DELETE_TITLE = 'DELETE_TITLE';
export const DENIED = 'DENIED';
export const DISTRIBUTE = 'DISTRIBUTE';
export const DOWNLOAD = 'DOWNLOAD';
export const DUPLICATE_TITLE = 'DUPLICATE_TITLE';
export const EDIT_TITLE = 'EDIT_TITLE';
export const ENVELOPE = 'ENVELOPE';
export const EXISTING_PUBLISHERS = 'EXISTING_PUBLISHERS';
export const FULFILLMENT = 'FULFILLMENT';
export const GEAR = 'GEAR';
export const GET_DENIAL_REASONS = 'GET_DENIAL_REASONS';
export const GET_DENIED = 'GET_DENIED';
export const GET_EXPORT_DENIED = 'GET_EXPORT_DENIED';
export const GET_IMPORT_DENIED = 'GET_IMPORT_DENIED';
export const HAMBURGER_MENU = 'HAMBURGER_MENU';
export const INFO_NEEDED = 'INFO_NEEDED';
export const LARGE_CLOSE = 'LARGE_CLOSE';
export const LOADER = 'LOADER';
export const LOCATION = 'LOCATION';
export const MANUAL = 'MANUAL';
export const NEEDS_ATTENTION = 'NEEDS_ATTENTION';
export const NEEDS_MATCH = 'NEEDS_MATCH';
export const NEW = 'NEW';
export const NEW_PUBLISHERS = 'NEW_PUBLISHERS';
export const NON_EXPIRING = 'Non-expiring';
export const NOTE = 'NOTE';
export const NOT_FOUND = 'NOT_FOUND';
export const NP_NEW = 'NP_NEW';
export const NP_PROCESSING = 'NP_PROCESSING';
export const NP_WAITING_LEGAL = 'NP_WAITING_LEGAL';
export const ONBOARDING = 'ONBOARDING';
export const ON_HOLD = 'ON_HOLD';
export const OPTIONS = 'OPTIONS';
export const PARENT_COMPANIES = 'PARENT_COMPANIES';
export const PENCIL = 'PENCIL';
export const PENDING = 'PENDING';
export const PROCESSING = 'PROCESSING';
export const PRODUCT_OPTIONS = 'PRODUCT_OPTIONS';
export const PUBLISHER_REVIEW = 'PUBLISHER_REVIEW';
export const PURGATORY = 'PURGATORY';
export const RECENT_COMPANIES = 'RECENT_COMPANIES';
export const REFRESH_REQUEST = 'REFRESH_REQUEST';
export const REQUEST = 'REQUEST';
export const REQUESTED = 'REQUESTED';
export const REQUESTED_TITLE = 'REQUESTED_TITLE';
export const REQUEST_RIGHTS = 'REQUEST_RIGHTS';
export const RETIRED = 'RETIRED';
export const RIGHTS_REQUESTS = 'RIGHTS_REQUESTS';
export const SEARCH = 'SEARCH';
export const SHARE = 'SHARE';
export const SHOW_REQUEST_ACTIVITY = 'SHOW_REQUEST_ACTIVITY';
export const SHOW_REQUEST_DETAILS = 'SHOW_REQUEST_DETAILS';
export const STATUS_CHANGE = 'STATUS_CHANGE';
export const SUBMITTED = 'SUBMITTED';
export const SUBSTITUTED = 'SUBSTITUTED';
export const SUBSTITUTE_TITLE = 'SUBSTITUTE_TITLE';
export const TRASH_CAN = 'TRASH_CAN';
export const UNAVAILABLE = 'UNAVAILABLE';
export const VST = 'VST';
export const WAITING_CUSTOMER = 'WAITING_CUSTOMER';
export const WAITING_INSTITUTION = 'WAITING_INSTITUTION';
export const WAITING_LEGAL = 'WAITING_LEGAL';
export const WAITING_PUBLISHER = 'WAITING_PUBLISHER';
export const WATCH = 'WATCH';
export const WATCHING = 'WATCHING';
